import type { GeoLocation } from '../../types/core';

/** Persists authority profile wizard data (sessionStorage). */
export const AUTHORITY_PROFILE_DRAFT_KEY = 'bn_authority_profile_draft_v1';

export interface AuthorityProfileDraft {
  authorityForm: Record<string, any>;
  schoolLocation?: GeoLocation;
  currentStepIndex: number;
}

export function saveAuthorityProfileDraft(draft: AuthorityProfileDraft): void {
  sessionStorage.setItem(AUTHORITY_PROFILE_DRAFT_KEY, JSON.stringify(draft));
}

export function loadAuthorityProfileDraft(): AuthorityProfileDraft | null {
  try {
    const raw = sessionStorage.getItem(AUTHORITY_PROFILE_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as AuthorityProfileDraft;
  } catch {
    return null;
  }
}

export function clearAuthorityProfileDraft(): void {
  sessionStorage.removeItem(AUTHORITY_PROFILE_DRAFT_KEY);
}
